<template>
  <div class="lang-switch">
    <span v-for="lang in languages" :key="lang.value" @click="selectLanguage(lang.value)">
      <RouterLink :to="{ params: { locale: lang.value}, name: current}">{{ lang.text }}</RouterLink>
    </span>
  </div>
</template>

<script>

const languages = [
  { value: 'sv', text: 'Svenska' },
  { value: 'fi', text: 'Suomeksi' }
]
export default {
  name: 'LanguageSelector',
  data () {
    return {
      current: this.$route.name
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    },
    languages () {
      return languages.filter(l => l.value !== this.language)
    },
    getLanguage () {
      const lang = languages.find(l => l.value === this.language)
      if (lang && lang.text) {
        return lang.text
      }
      return ''
    }
  },
  methods: {
    selectLanguage (language) {
      this.$store.commit('language', { language })
    }
  }
}
</script>
